import React from 'react'

import './ChannelsTab.css';

export default function ChannelsTab() {
  return (
    <div style={{ margin: '24px', color: 'var(--gray-light)' }}>[Sorry! This page is currently under construction!]</div>
  )
}
